import { NavLink } from "react-router-dom";


const JNavLink = (props) => {

    return (<NavLink to={props.to} style={{
        textDecoration: "none",
        color: "white",
        fontWeight: 500,
        display: "flex",
        padding: "8px",
      }}
      activeStyle={{
        backgroundColor: "rgba(255, 255, 255, 0.08)",
        color: "#10b981",
        borderRadius: "8px",
        fontWeight: 500,
        // padding: "6px 0px 6px 0px"
      }}
      >{props.children}</NavLink>)
}

export default JNavLink;